import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

const styles = css`
	background: #fff;
	border: 1px solid #d3d4d4;
	border-radius: 2px;
	box-sizing: border-box;
	font-family: Houschka-Alt-Pro Display Bold, sans-serif;
	padding: 1rem;
	text-align: center;
`;

const TotalBar = ({ currencySymbol, label, total }) => (
	<div className={styles}>
		<span>
			{label}: {currencySymbol}
			{total}
		</span>
	</div>
);

TotalBar.propTypes = {
	/** Currency symbol. */
	currencySymbol: PropTypes.string,
	/** Label shown alongside total. */
	label: PropTypes.string,
	/** The total amount, pre-formatted minus currency. */
	total: PropTypes.string.isRequired,
};
TotalBar.defaultProps = {
	currencySymbol: '£',
	label: 'Total',
};

export { TotalBar };
